import { CurrencySymbol } from 'shared/interface/globalInterface';
import { Nullable, typeCheck } from 'utils/types';

export const addTousentSeparator = (value: string, separator: string = ',') => {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

const formatCurrencyValue = (value: string | number) => {
  return `${CurrencySymbol}${addTousentSeparator(`${value}`)}`;
};

export const NOT_AVAILABLE = 'N/A';

export const formatCurrency = (value: Nullable<string | number>, addValueSign: boolean = false): string => {
  const addSign = (value: number, formatted: string): string => {
    return (Number(value) > 0 ? `+` : '-') + formatted.replace('-', '');
  };
  if (typeCheck<number | string>(value, 'number', 'string')) {
    const formattedCurrencyValue = formatCurrencyValue(value.toString());

    return addValueSign ? addSign(Number(value), formattedCurrencyValue) : formattedCurrencyValue;
  } else {
    return NOT_AVAILABLE;
  }
};

export default formatCurrencyValue;
